import AlertLine from '@/assets/icons/ri_alert_line.svg?component';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import { TooltipTrigger } from '@/components/atoms/Tooltip';

import styles from './WarningMarker.module.scss';

// Whole pixels, in a circle sized in whole pixels too: at the 1em it inherited (13.6px in
// the pen table, 11.2px on a KPI card) the icon's strokes fell between pixels and drew
// blurred and uneven on a 1x screen.
const ICON_SIZE_PX = 14;

export interface WarningIconProps {
    /** The conditions met, as the button's accessible name. */
    label: string;
}

/**
 * The warning state's marker, one for the pen table and the KPI cards so both read alike.
 * A button, so a keyboard or touch user can open the conditions the way a pointer does:
 * focus opens the tooltip, and pressing it does nothing more. Callers wrap it in the shared
 * Tooltip, which portals the bubble into the body, so neither the table's horizontal scroll
 * container nor the KPI grid clips it or grows around it.
 */
export function WarningIcon(props: WarningIconProps) {
    return (
        <TooltipTrigger className={styles.marker} label={props.label}>
            <SvgIcon
                icon={AlertLine}
                size="custom"
                customSize={ICON_SIZE_PX}
                svgProps={{ 'aria-hidden': true, 'focusable': 'false' }}
            />
        </TooltipTrigger>
    );
}
